"use client";

import React from "react";
import "./ClientTestimonials.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const videos = [
  {
    id: 1,
    url: "https://www.w3schools.com/html/mov_bbb.mp4",
  },
  {
    id: 2,
    url: "https://www.w3schools.com/html/movie.mp4",
  },
  {
    id: 3,
    url: "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
  {
    id: 4,
    url: "https://www.w3schools.com/html/mov_bbb.mp4",
  },
  {
    id: 5,
    url: "https://www.w3schools.com/html/movie.mp4",
  },
];

function ClientTestimonials() {
  return (
    <section className="section-padding light-bg-section client-testimonials">
      <div className="main-container">
        {/* Header 
            flex-rwo
        */}
        <div className="testimonial-header">
          <h2>CLIENT TESTIMONIALS</h2>

          <div className="nav-buttons">
            <div className="swiper-button-prev custom-prev"></div>
            <div className="swiper-button-next custom-next"></div>
          </div>
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 1.5,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          className="testimonial-swiper"
        >
          {videos.map((video) => (
            <SwiperSlide key={video.id}>
              <div className="video-card">
                <video
                  src={video.url}
                  controls
                  playsInline
                  preload="metadata"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default ClientTestimonials;
